var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVec33(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.7 0H15.3C11.2422 0 7.35057 1.61194 4.48127 4.4812C1.61196 7.35047 0 11.242 0 15.2998V66.2991C0 70.3568 1.61196 74.2484 4.48127 77.1177C7.35057 79.9869 11.2422 81.5989 15.3 81.5989H74.409L93.279 100.52C93.7555 100.992 94.3207 101.366 94.9421 101.62C95.5634 101.874 96.2288 102.002 96.9 101.999C97.569 102.016 98.2327 101.876 98.838 101.591C99.7694 101.208 100.567 100.558 101.129 99.7233C101.692 98.8883 101.995 97.9055 102 96.8987V15.2998C102 11.242 100.388 7.35047 97.5187 4.4812C94.6494 1.61194 90.7578 0 86.7 0ZM91.8 84.6078L80.121 72.878C79.6445 72.4053 79.0793 72.0314 78.4579 71.7776C77.8366 71.5238 77.1712 71.3951 76.5 71.399H15.3C13.9474 71.399 12.6502 70.8617 11.6938 69.9053C10.7373 68.9488 10.2 67.6517 10.2 66.2991V15.2998C10.2 13.9472 10.7373 12.65 11.6938 11.6936C12.6502 10.7372 13.9474 10.1999 15.3 10.1999H86.7C88.0526 10.1999 89.3498 10.7372 90.3063 11.6936C91.2627 12.65 91.8 13.9472 91.8 15.2998V84.6078Z",
    fill: "url(#paint0_linear_36_4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36_4",
    x1: 15,
    y1: -6.99204e-7,
    x2: 116.03,
    y2: 98.5733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D70F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E2029"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVec33);
export default __webpack_public_path__ + "static/media/vec33.00a2e1de7ba2f515fb114dc232de9a22.svg";
export { ForwardRef as ReactComponent };